import {Component, OnDestroy, OnInit} from '@angular/core';
import {finalize, take, takeUntil} from 'rxjs/operators';
import {CustomerService} from '@iw-shop/customer/services/customer.service';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {Subject} from 'rxjs';
import {ArticleService} from '@iw-shop/article/services/article.service';
import {UserService} from '@iw-shop/user/services/user.service';
import {getSelectedCustomer} from '@store/selectors/user.selector';
import {ApiCustomerDocument} from '@api/customer-documents';
import {NumberFormat} from '@iw-shop/core//functions/number-format';
import {PageEvent} from "@iw-shop/core/components/paginator/paginator.component";

@Component({
    selector: 'iw-shop-customer-documents',
    standalone: false,
    templateUrl: './customer-documents.component.html',
    styleUrls: ['./customer-documents.component.scss']
})
export class CustomerDocumentsComponent implements OnInit, OnDestroy {

    destroy$: Subject<boolean> = new Subject<boolean>();

    loading: boolean = true;
    customerId: string = '';
    customerNumber: string | null = null;
    customerInvoices: ApiCustomerDocument[] = [];

    currency: 'EUR' | 'CHF' = 'EUR';

    start = 0;
    limit = 40;
    length = this.customerInvoices.length;


    constructor(private store: Store<AppState>, private customerService: CustomerService, public articleService: ArticleService, private userService: UserService) {
        this.store.select(state => state.config).pipe(take(1)).subscribe(r => {
            this.currency = r.currency
        });
    }

    isAccess(): boolean {
        return this.userService.hasLoggedInUserAccess({type: 'invoices', customerId: this.customerId});
    }

    ngOnInit(): void {
        this.store.select(
            getSelectedCustomer
        )
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe(
                customer => {
                    this.customerId = customer?.id || '';
                    if (customer?.customerNumber) {
                        this.customerNumber = customer.customerNumber;
                        if (this.isAccess()) {
                            this.loadCustomerInvoices();
                        }
                    } else {
                        this.loading = false;
                    }

                }
            )
    }

    downloadInvoice(id: string) {
        if (this.customerNumber) {
            this.customerService.downloadDocument(id, this.customerNumber);
        }
    }


    changePage(event: PageEvent) {

        this.start = event.start;
        this.limit = event.limit;
        window.scrollTo({
            top: 0
        });

    }
    loadCustomerInvoices() {
        if (this.customerNumber) {
            this.loading = true;
            this.customerService.getDocuments(this.customerNumber, ['invoice'], this.start, this.limit)
                .pipe(
                    finalize(() => {
                            this.loading = false;
                        }
                    )
                )
                .subscribe(
                    r => {
                        if (r.result?.customerDocuments.data) {
                            this.length = r.result.customerDocuments.count.filtered;
                            this.customerInvoices = r.result?.customerDocuments.data;
                        }
                    }
                )
        } else {
            this.loading = false;
        }
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    protected readonly NumberFormat = NumberFormat;
}
